var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "avatar flex-center" },
    [
      _vm.imgObj.img
        ? _c("el-image", {
            ref: "previewImg",
            staticStyle: { "border-radius": "6px" },
            style: { width: "80px", height: "80px" },
            attrs: {
              src: _vm.imgObj.img,
              "preview-src-list": [_vm.imgObj.img],
            },
          })
        : _vm._e(),
      _c("div", { staticClass: "operate flex-center padding-x-10" }, [
        _c("i", {
          staticClass:
            "el-icon-zoom-in color-fff font-weight font-18 margin-right-15",
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.handlePictureCardPreview.apply(null, arguments)
            },
          },
        }),
        _c("i", {
          staticClass:
            "el-icon-download color-fff font-weight font-18 margin-right-15",
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.handleDownload(_vm.imgObj)
            },
          },
        }),
        _c("i", {
          staticClass: "el-icon-delete color-fff font-weight font-18",
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.handleRemove(_vm.imgObj.id)
            },
          },
        }),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }